import { PathContext } from '@new/common/hooks/usePathContext';

export const buildCoursePath = ({
  degreeId,
  courseId,
}: Pick<PathContext, 'degreeId' | 'courseId'>): string => {
  if (degreeId && courseId) return `/degrees/${degreeId}/courses/${courseId}`;
  if (courseId) return `/courses/${courseId}`;
  return '/courses';
};

export const buildLessonPath = ({ degreeId, courseId, lessonId }: PathContext): string => {
  if (degreeId && courseId && lessonId)
    return `/degrees/${degreeId}/courses/${courseId}/lessons/${lessonId}`;
  if (courseId && lessonId) return `/courses/${courseId}/lessons/${lessonId}`;
  if (lessonId) return `/lessons/${lessonId}`;
  return '/courses';
};

export const buildObjectivePath = (
  { degreeId, courseId, lessonId }: PathContext,
  objectiveId: number
): string => {
  if (degreeId && courseId && lessonId) {
    return `/degrees/${degreeId}/courses/${courseId}/lessons/${lessonId}/objectives/${objectiveId}`;
  }
  if (courseId && lessonId) {
    return `/courses/${courseId}/lessons/${lessonId}/objectives/${objectiveId}`;
  }
  if (courseId) {
    return `/courses/${courseId}/objectives/${objectiveId}`;
  }
  if (lessonId) {
    return `/lessons/${lessonId}/objectives/${objectiveId}`;
  }
  return `/objectives/${objectiveId}`;
};
